<template>
  <div :style="{ display: block ? 'block' : 'inline-block' }">
    <span class="price flex-inline align-base" :style="{ fontSize: size + 'px', color, fontWeight: bold }">
      <i class="unit" v-if="showSymbol">¥</i>
      <strong>{{ priceArr[0] }}</strong>
      <i v-if="decimal > 0">.</i>
      <i class="decimal" :class="{ camel: camelDecimal }">{{ priceArr[1] }}</i>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    realPrice: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: '14'
    },
    unit: {
      type: String,
      default: 'fen'
    },
    decimal: {
      type: Number,
      default: 2
    },
    block: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#F23400'
    },
    bold: {
      type: Number,
      default: 500
    },
    showSymbol: {
      type: Boolean,
      default: true
    },
    camelDecimal: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    priceArr() {
      return (this.unit === 'fen' ? this.realPrice / 100 : this.realPrice)
        .toFixed(Number(this.decimal))
        .toString()
        .split('.');
    }
  }
};
</script>

<style lang="less" scoped>
.price {
  line-height: 24px;
  font-size: 0.7em;
  .unit {
    font-size: 0.7em;
  }
  strong {
    font-size: 1em;
  }
  .decimal {
    &.camel {
      font-size: 0.7em;
    }
  }
}
</style>
